import { render } from "./CloneProcessDashboard.vue?vue&type=template&id=2823f432"
import script from "./CloneProcessDashboard.vue?vue&type=script&lang=js"
export * from "./CloneProcessDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__